import React from 'react'
import classnames from 'classnames'

import Layout from 'components/shared/Layout'
import GradientHeaderWithIntro from 'components/shared/GradientHeaderWithIntro'
import FAQ from 'components/shared/FAQ'

import css from './styles.module.scss'

const FrequentlyAskedQuestions = ({
  className,
  intro,
  gradientHeader,
  categories,
}) => {
  const componentStyle = classnames(
    css.FrequentlyAskedQuestionsSlice,
    className
  )

  return (
    <div className={componentStyle}>
      <GradientHeaderWithIntro
        intro={intro}
        introProps={{ className: css.intro }}
        gradientHeader={gradientHeader}
      />
      <Layout tag="section" type="maxWidth">
        {/* <Layout type="wrapper"> */}
        <FAQ categories={categories} />
        {/* </Layout> */}
      </Layout>
    </div>
  )
}

export default FrequentlyAskedQuestions
